<template>
    <div class="document-header">
        <div class="document-header-verified" v-if="isOrganizationVerified">
            <div class="document-header-data">
                <span class="document-header-data-title">{{$t(`${headerKeyPrefix}.verified.title`)}}</span>
                <span class="document-header-data-short-description" v-html="$t(`${headerKeyPrefix}.verified.content`, {organizationName: issuerProfileFullname})"></span>
            </div>
        </div>
        <div class="document-header-unverified" v-if="!isOrganizationVerified">
            <div class="document-header-data">
                <span class="document-header-data-title">{{$t(`${headerKeyPrefix}.unverified.title`)}}</span>
                <span class="document-header-data-short-description" v-html="$t(`${headerKeyPrefix}.unverified.content`, {organizationName: issuerProfileFullname})"></span>
            </div>
        </div>
        <div class="document-header-owner">
            <div class="document-header-picture" v-if="ownerProfilePictureUrl">
                <img :src="ownerProfilePictureUrl">
            </div>
            <div class="document-header-data">
                <span class="document-header-data-title">{{$t(`${headerKeyPrefix}.owner.title`)}}</span>
                <span class="document-header-data-fullname">{{ownerProfileFullname}}</span>
                <span class="document-header-data-short-description">{{ownerProfileShortDescription}}</span>
                <a target="_blank" :href="ownerProfileUrl" class="document-header-data-link">{{$t(`${headerKeyPrefix}.owner.link`)}}</a>
            </div>
        </div>
        <!-- <div class="document-header-issuer">
            <div class="document-header-picture" v-if="issuerProfilePictureUrl">
                <img :src="issuerProfilePictureUrl">
            </div>
            <div class="document-header-data">
                <span class="document-header-data-title">{{$t(`${headerKeyPrefix}.issuer.title`)}}</span>
                <span class="document-header-data-fullname">{{issuerProfileFullname}}</span>
                <span class="document-header-data-short-description">{{issuerProfileShortDescription}}</span>
                <a target="_blank" :href="issuerProfileUrl" class="document-header-data-link">{{$t(`${headerKeyPrefix}.issuer.link`)}}</a>
            </div>
        </div> -->
    </div>
</template>

<i18n>
{
    "en": {
        "document": {
            "header": {
                "document": {
                    "verified": {
                        "title": "Congratulations!",
                        "content": "You opened a duly certified Smart Certificate document issued by <b>{organizationName}</b>. It's trustworthy and ensures the owner's integrity."
                    },
                    "unverified": {
                        "title": "This document is being checked",
                        "content": "The issuer of this document, <b>{organizationName}</b>, is being verified. Therefore, the authenticity and the validity of this document is not yet certified by Smart Certificate."
                    },
                    "owner": {
                        "title": "Document's owner",
                        "link": "View owner profile"
                    },
                    "issuer": {
                        "title": "Document's issuer",
                        "link": "View issuer profile"
                    }
                },
                "badge": {
                    "verified": {
                        "title": "Congratulations!",
                        "content": "You opened a duly certified Smart Certificate badge issued by <b>{organizationName}</b>. It's trustworthy and ensures the badge owner's integrity."
                    },
                    "unverified": {
                        "title": "This badge is being checked",
                        "content": "The issuer of this badge, <b>{organizationName}</b>, is being verified. Therefore, the authenticity and the validity of this badge are not yet certified by Smart Certificate."
                    },
                    "owner": {
                        "title": "Badge owner",
                        "link": "View owner profile"
                    },
                    "issuer": {
                        "title": "Badge issuer",
                        "link": "View issuer profile"
                    }
                }
            }
        }
    },
    "es": {
        "document": {
            "header": {
                "document": {
                    "verified": {
                        "title": "Enhorabuena.",
                        "content": "Ha abierto un documento de Smart Certificate debidamente certificado y emitido por <b>{organizationName}</b>. Es de confianza y garantiza la integridad del propietario."
                    },
                    "unverified": {
                        "title": "Este documento está siendo verificado",
                        "content": "El emisor de este documento, <b>{organizationName}</b>, está siendo verificado. Por lo tanto, la autenticidad y la validez de este documento aún no están certificadas por Smart Certificate."
                    },
                    "owner": {
                        "title": "Propietario del documento",
                        "link": "Ver perfil del propietario"
                    },
                    "issuer": {
                        "title": "Emisor del documento",
                        "link": "Ver perfil del emisor"
                    }
                },
                "badge": {
                    "verified": {
                        "title": "Enhorabuena.",
                        "content": "Has abierto un insignia Smart Certificate debidamente certificado y insignia por <b>{organizationName}</b>. Es fiable y garantiza la integridad insignia ."
                    },
                    "unverified": {
                        "title": "insignia comprobando esta insignia",
                        "content": "Se está verificando la identidad del emisor de esta insignia, <b>{organizationName}</b>. Por lo tanto, Smart Certificate aún no insignia certificado la autenticidad ni la validez de esta insignia ."
                    },
                    "owner": {
                        "title": "insignia",
                        "link": "Ver perfil del propietario"
                    },
                    "issuer": {
                        "title": "insignia",
                        "link": "Ver perfil del emisor"
                    }
                }
            }
        }
    },
    "fr": {
        "document": {
            "header": {
                "document": {
                    "verified": {
                        "title": "Félicitations !",
                        "content": "Vous avez ouvert un document Smart Certificate dûment certifié émis par <b>{organizationName}</b>. Il est fiable et garantit l'intégrité du propriétaire."
                    },
                    "unverified": {
                        "title": "Ce document est en cours de vérification",
                        "content": "L'émetteur de ce document, <b>{organizationName}</b>, est en cours de vérification. Par conséquent, l'authenticité et la validité de ce document ne sont pas encore certifiées par Smart Certificate."
                    },
                    "owner": {
                        "title": "Propriétaire du document",
                        "link": "Voir le profil du propriétaire"
                    },
                    "issuer": {
                        "title": "Émetteur du document",
                        "link": "Voir le profil de l'émetteur"
                    }
                },
                "badge": {
                    "verified": {
                        "title": "Félicitations !",
                        "content": "Vous avez ouvert un badge Smart Certificate dûment certifié, badge par <b>{organizationName}</b>. badge est fiable et garantit l'intégrité badge ."
                    },
                    "unverified": {
                        "title": "Ce badge en cours de vérification",
                        "content": "L'émetteur de ce badge, <b>{organizationName}</b>, fait actuellement l'objet d'une vérification. Par conséquent, l'authenticité et la validité de ce badge pas encore badge certifiées par Smart Certificate."
                    },
                    "owner": {
                        "title": "Badge",
                        "link": "Voir le profil du propriétaire"
                    },
                    "issuer": {
                        "title": "Badge",
                        "link": "Voir le profil de l'émetteur"
                    }
                }
            }
        }
    },
    "pt": {
        "document": {
            "header": {
                "document": {
                    "verified": {
                        "title": "Parabéns!",
                        "content": "Abriu um documento Smart Certificate devidamente certificado emitido pela <b>{organizationName}</b>. É de confiança e garante a integridade do proprietário."
                    },
                    "unverified": {
                        "title": "Este documento está a ser verificado",
                        "content": "O emissor deste documento, <b>{organizationName}</b>, está a ser verificado. Por conseguinte, a autenticidade e a validade deste documento ainda não estão certificadas pelo Smart Certificate."
                    },
                    "owner": {
                        "title": "Proprietário do documento",
                        "link": "Ver perfil do proprietário"
                    },
                    "issuer": {
                        "title": "Emissor do documento",
                        "link": "Ver perfil do emitente"
                    }
                },
                "badge": {
                    "verified": {
                        "title": "Parabéns!",
                        "content": "Abriu um insígnia Smart Certificate devidamente certificado, insígnia pela <b>{organizationName}</b>. É fiável e garante a integridade insígnia ."
                    },
                    "unverified": {
                        "title": "Esta insígnia a ser verificada",
                        "content": "O emissor desta insígnia, <b>{organizationName}</b>, está a ser verificado. Por conseguinte, a autenticidade e a validade desta insígnia ainda não insígnia certificadas pela Smart Certificate."
                    },
                    "owner": {
                        "title": "insígnia",
                        "link": "Ver perfil do proprietário"
                    },
                    "issuer": {
                        "title": "insígnia",
                        "link": "Ver perfil do emitente"
                    }
                }
            }
        }
    },
    "de": {
        "document": {
            "header": {
                "document": {
                    "verified": {
                        "title": "Herzlichen Glückwunsch!",
                        "content": "Sie haben ein ordnungsgemäß beglaubigtes Smart-Zertifikat geöffnet, das von <b>{Organisationsname}</b> ausgestellt wurde. Es ist vertrauenswürdig und gewährleistet die Integrität des Inhabers."
                    },
                    "unverified": {
                        "title": "Dieses Dokument wird gerade geprüft",
                        "content": "Der Aussteller dieses Dokuments, <b>{Organisationsname}</b>, wird derzeit überprüft. Daher ist die Authentizität und Gültigkeit dieses Dokuments noch nicht durch Smart Certificate zertifiziert."
                    },
                    "owner": {
                        "title": "Der Eigentümer des Dokuments",
                        "link": "Eigentümerprofil ansehen"
                    },
                    "issuer": {
                        "title": "Emittent des Dokuments",
                        "link": "Emittentenprofil ansehen"
                    }
                },
                "badge": {
                    "verified": {
                        "title": "Herzlichen Glückwunsch!",
                        "content": "Sie haben ein ordnungsgemäß zertifiziertes badge geöffnet, das von <b>{organizationName}</b> badge . Es ist vertrauenswürdig und garantiert die Integrität badge ."
                    },
                    "unverified": {
                        "title": "Dieses badge gerade überprüft",
                        "content": "Der Aussteller dieses badge, <b>{organizationName}</b>, wird derzeit überprüft. Daher badge die Echtheit und Gültigkeit dieses badge noch nicht von Smart Certificate bestätigt."
                    },
                    "owner": {
                        "title": "Badge",
                        "link": "Eigentümerprofil ansehen"
                    },
                    "issuer": {
                        "title": "Badge",
                        "link": "Emittentenprofil ansehen"
                    }
                }
            }
        }
    },
    "nl": {
        "document": {
            "header": {
                "document": {
                    "verified": {
                        "title": "Gefeliciteerd!",
                        "content": "U opende een naar behoren gecertificeerd Smart Certificate document uitgegeven door <b>{organisatienaam}</b>. Het is betrouwbaar en verzekert de integriteit van de eigenaar."
                    },
                    "unverified": {
                        "title": "Dit document wordt gecontroleerd",
                        "content": "De uitgever van dit document, <b>{organizationName}</b>, wordt geverifieerd. Daarom zijn de authenticiteit en de geldigheid van dit document nog niet gecertificeerd door Smart Certificate."
                    },
                    "owner": {
                        "title": "Eigenaar van het document",
                        "link": "Profiel van eigenaar bekijken"
                    },
                    "issuer": {
                        "title": "Uitgevende instelling van het document",
                        "link": "Bekijk het profiel van de emittent"
                    }
                },
                "badge": {
                    "verified": {
                        "title": "Gefeliciteerd!",
                        "content": "U hebt een officieel gecertificeerde Smart badge geopend badge door <b>{organizationName}</b>. badge is betrouwbaar en garandeert de integriteit badge ."
                    },
                    "unverified": {
                        "title": "Deze badge momenteel gecontroleerd",
                        "content": "De uitgever van dit badge, <b>{organizationName}</b>, wordt momenteel gecontroleerd. Daarom badge de authenticiteit en de geldigheid van dit badge nog niet door Smart Certificate bevestigd."
                    },
                    "owner": {
                        "title": "Badge",
                        "link": "Profiel van eigenaar bekijken"
                    },
                    "issuer": {
                        "title": "Badge",
                        "link": "Bekijk het profiel van de emittent"
                    }
                }
            }
        }
    }
}
</i18n>

<script>
import { getModule } from '@/modules/store'
import ConfigStore from '@/modules/config/store/ConfigStore'

import { PublicDocument } from '@/modules/documents/models/PublicDocument'

export default {
    components: {
    },
    props: {
        publicDocument: {
            type: PublicDocument
        }
    },
    data() {
        return {
            isLoading: false,
            hidePictureIfEmpty: true
        }
    },
    computed: {
        configStore() {
            return getModule(ConfigStore)
        },
        ownerProfilePictureUrl() {
            return this.publicDocument.recipientPictureUrl ? this.$processUrl(this.publicDocument.recipientPictureUrl) : this.hidePictureIfEmpty ? '' : require('@/assets/v3/img/icons/user-dark.png')
            // return this.configStore.user.pictureUrl || this.hidePictureIfEmpty ? '' : require('@/assets/v3/img/icons/user-dark.png')
        },
        ownerProfileFullname() {
            return this.publicDocument.recipientName
            // return this.configStore.user.firstName + (this.configStore.user.lastName ? ' ' + this.configStore.user.lastName : '')
        },
        ownerProfileShortDescription() {
            return this.publicDocument.recipientShortDescription
            // return this.configStore.user.shortDescription
        },
        ownerProfileUrl() {
            return this.publicDocument.recipientPublicProfileUrl
        },
        issuerProfilePictureUrl() {
            return this.publicDocument.organizationLogo ? this.$processUrl(this.publicDocument.organizationLogo) : this.hidePictureIfEmpty ? '' : require('@/assets/v3/img/icons/user-dark.png')
            // return this.configStore.organizationPictureUrl || this.hidePictureIfEmpty ? '' : require('@/assets/v3/img/icons/user-dark.png')
        },
        issuerProfileFullname() {
            return this.publicDocument.organizationName
            // return this.configStore.organizationName
        },
        issuerProfileShortDescription() {
            return this.publicDocument.folderTitle
            // return this.configStore.folderName
        },
        issuerProfileUrl() {
            let url = this.publicDocument.organizationWebsiteUrl
            // make sure url is a full url starting with https
            if(url && !url.startsWith('https')) {
                url = 'https://' + url
            }
            return url
        },
        isOrganizationVerified() {
            return this.publicDocument.isVerified === true
        },
        isBadge() {
            const url = this.publicDocument && this.publicDocument.documentPdfUrl ? this.publicDocument.documentPdfUrl : ''
            return url.toLowerCase().includes('badge')
        },
        headerKeyPrefix() {
            return this.isBadge ? 'document.header.badge' : 'document.header.document'
        }
    },
    methods: {
    }
}
</script>

<style lang="stylus">
@import "~assets/v3/css/variables.styl";
@import "./../css/public-document.styl";

.document-header
    display flex
    flex-direction row
    // gap 10px
    responsive-styling-auto-scale(gap, 10, $responsive-max-width)

    .document-header-verified
    .document-header-unverified
    .document-header-owner
    .document-header-issuer
        border-radius 5px
        background-color white
        display flex
        flex-direction row
        flex 1 1 auto
        width 50%
        justify-content flex-start
        align-items flex-start

    .document-header-picture
        flex 0 0 auto
        // width 140px
        // height 140px
        responsive-styling-auto-scale(width, 140, $responsive-max-width)
        responsive-styling-auto-scale(height, 140, $responsive-max-width)
        position relative
        // margin-right 12px
        // responsive-styling-auto-scale(margin-right, 12, $responsive-max-width)
        border-radius 5px 0 0 5px
        overflow hidden
        border-right #EBEBEB 1px solid

        img
            position absolute
            top 0
            left 0
            width 100%
            height 100%
            object-fit cover

    .document-header-data
        display flex
        flex-direction column
        justify-content flex-start
        box-sizing border-box
        min-height 100%
        // gap 4px
        responsive-styling-auto-scale(gap, 4, $responsive-max-width)
        responsive-styling-auto-scale(padding, 12, $responsive-max-width)

        div+&
            responsive-styling-auto-scale(padding-left, 24, $responsive-max-width)
            responsive-styling-auto-scale(padding-right, 24, $responsive-max-width)

        .document-header-data-title
            color #9F9F9F
            // font-size 16px
            responsive-styling-auto-scale(font-size, 16, $responsive-max-width)
            font-weight medium

        .document-header-data-fullname
            font-weight bold
            // font-size 24px
            responsive-styling-auto-scale(font-size, 24, $responsive-max-width)
            color black

        .document-header-data-short-description
            font-weight regular
            // font-size 18px
            responsive-styling-auto-scale(font-size, 18, $responsive-max-width)
            color black

        .document-header-data-link
            display flex
            align-items center
            responsive-styling-auto-scale(font-size, 16, $responsive-max-width)

            &::after
                margin-left 4px
                content "\e934"
                font-family: 'SmartCertificateV3' !important;
                speak: never;
                font-style: normal;
                font-weight: normal;
                font-variant: normal;
                text-transform: none;
                line-height: 1;

                /* Better Font Rendering =========== */
                -webkit-font-smoothing: antialiased;
                -moz-osx-font-smoothing: grayscale;

    .document-header-verified
        background-color #67c23a

        .document-header-data-title
            color rgba(255, 255, 255, 0.75)

        .document-header-data-short-description
            color white
            responsive-styling-auto-scale(font-size, 16, $responsive-max-width)

    .document-header-unverified
        background-color #FB5788

        .document-header-data-title
            color rgba(255, 255, 255, 0.75)

        .document-header-data-short-description
            color white
            responsive-styling-auto-scale(font-size, 16, $responsive-max-width)


    @media screen and (max-width: 846px)
        flex-direction column

        .document-header-owner
        .document-header-issuer
        .document-header-verified
        .document-header-unverified
            width 100%
</style>



// WEBPACK FOOTER //
// src/modules/documents/components/PublicDocumentHeader.vue